import { useEffect, useState } from 'react';
import { useTX } from '@transifex/react';
import { errorReporter } from '@flow/logging';

export const useTranslationsIsReady = (tx: ReturnType<typeof useTX>, language: string): boolean => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    tx.setCurrentLocale(language)
      .then(() => {
        setIsReady(true);
      })
      .catch(() => {
        if (navigator.onLine) {
          errorReporter.error('Failed to load translations');
        }
        // Fallback to default language if loading fails
        setIsReady(true);
      });
  }, [
    language,
    tx,
  ]);

  return isReady;
};
